/**
 * useUnlockedThemes — lê o inventário de temas desbloqueados do utilizador.
 *
 * Lê `unlockedThemes` do profile já subscrito em AuthContext (subscribeToUserProfile),
 * eliminando um listener onSnapshot redundante em users/{uid}.
 *
 * Temas gratuitos (default, noir, cerejeira) são sempre considerados desbloqueados.
 */
import { useAuth } from "../../../hooks/useAuth";

/** IDs gratuitos — sempre acessíveis sem compra */
export const FREE_STORE_THEME_IDS = ["default", "noir", "cerejeira"] as const;

function mergeWithFree(ids: string[]): string[] {
  const set = new Set([...FREE_STORE_THEME_IDS, ...ids]);
  return [...set];
}

interface UseUnlockedThemesResult {
  unlockedIds: string[];
  isLoading: boolean;
}

/**
 * Hook READ-ONLY: `unlockedThemes` é client-locked nas rules — quem escreve é
 * a CF `spendCoins` (THEME_PURCHASE), na mesma transação do débito. O antigo
 * `unlockTheme` (updateDoc client) era permission-denied garantido e foi a
 * causa do bug crítico da loja (moedas debitadas sem entrega, 19/07).
 */
export function useUnlockedThemes(): UseUnlockedThemesResult {
  const { profile, isLoading: authLoading } = useAuth();

  const stored: string[] = Array.isArray(profile?.unlockedThemes)
    ? (profile.unlockedThemes as string[])
    : [];

  return {
    unlockedIds: mergeWithFree(stored),
    isLoading: authLoading,
  };
}
